import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "modal_content" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h4", null, "Money out your e-wallet", -1)
const _hoisted_4 = { class: "modal_form" }
const _hoisted_5 = { class: "form_wrapper" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "form_wrapper__title" }, [
  /*#__PURE__*/_createElementVNode("label", null, "Name")
], -1)
const _hoisted_7 = { class: "form_wrapper" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "form_wrapper__title" }, [
  /*#__PURE__*/_createElementVNode("label", null, "Account Number")
], -1)
const _hoisted_9 = { class: "form_wrapper" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "form_wrapper__title" }, [
  /*#__PURE__*/_createElementVNode("label", null, "Sort code")
], -1)
const _hoisted_11 = { class: "form_wrapper" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "form_wrapper__title" }, [
  /*#__PURE__*/_createElementVNode("label", null, "Reference")
], -1)
const _hoisted_13 = { class: "form_wrapper" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "form_wrapper__title" }, [
  /*#__PURE__*/_createElementVNode("label", null, "Enter Money Amount")
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", null, "£", -1)
const _hoisted_16 = { class: "text-orange" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "notes__wrapper tw-pb-4" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" By agreeing and continuing you consent to us requesting funds from your selected bank and sharing your account details with them. "),
    /*#__PURE__*/_createElementVNode("span", null, "Terms & conditions apply."),
    /*#__PURE__*/_createTextVNode(" You will be redirected to your bank app for payment. ")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_Button = _resolveComponent("Button")!
  const _component_CommonDialog = _resolveComponent("CommonDialog")!
  const _component_TransactionSuccessfulModal = _resolveComponent("TransactionSuccessfulModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!$setup.isShowTransactionSuccessfulModal)
      ? (_openBlock(), _createBlock(_component_CommonDialog, {
          key: 0,
          isShowHeader: false,
          isShowBackButton: false,
          className: ['money_out_e_wallet_modal'],
          width: "570px",
          height: "auto"
        }, {
          body: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _hoisted_3,
                _createVNode(_component_v_btn, {
                  icon: "mdi-close",
                  onClick: $setup.onClickCloseButton
                }, null, 8, ["onClick"])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createVNode(_component_v_text_field, {
                    class: "input_field",
                    rules: $setup.validation.name,
                    modelValue: $setup.userInformation.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.userInformation.name) = $event)),
                    variant: "outlined",
                    placeholder: "Enter Name"
                  }, null, 8, ["rules", "modelValue"])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createVNode(_component_v_text_field, {
                    class: "input_field",
                    rules: $setup.validation.accountNumber,
                    modelValue: $setup.userInformation.accountNumber,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.userInformation.accountNumber) = $event)),
                    variant: "outlined",
                    placeholder: "Enter Account Number"
                  }, null, 8, ["rules", "modelValue"])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createVNode(_component_v_text_field, {
                    class: "input_field",
                    rules: $setup.validation.sortCode,
                    modelValue: $setup.userInformation.sortCode,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.userInformation.sortCode) = $event)),
                    variant: "outlined",
                    placeholder: "Enter Sort code"
                  }, null, 8, ["rules", "modelValue"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createVNode(_component_v_text_field, {
                    class: "input_field",
                    rules: $setup.validation.reference,
                    modelValue: $setup.userInformation.reference,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.userInformation.reference) = $event)),
                    variant: "outlined",
                    placeholder: "Enter Reference"
                  }, null, 8, ["rules", "modelValue"])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createVNode(_component_v_text_field, {
                    class: "input_field",
                    rules: $setup.validation.amount,
                    modelValue: $setup.formattedHourlyRate,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.formattedHourlyRate) = $event)),
                    onBlur: $setup.formatHourlyRate,
                    variant: "outlined",
                    placeholder: "1000.00"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_15
                    ]),
                    _: 1
                  }, 8, ["rules", "modelValue", "onBlur"]),
                  _createElementVNode("p", null, [
                    _createTextVNode(" Available balance "),
                    _createElementVNode("span", _hoisted_16, "£" + _toDisplayString($setup.userAvailableBalance), 1)
                  ])
                ])
              ]),
              _hoisted_17,
              _createVNode(_component_Button, {
                variant: "accent",
                label: "Agree & Continue",
                onClick: $setup.onClickSaveButton,
                disabled: $setup.isSaveButtonDisable
              }, null, 8, ["onClick", "disabled"])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    ($setup.isShowTransactionSuccessfulModal)
      ? (_openBlock(), _createBlock(_component_TransactionSuccessfulModal, {
          key: 1,
          balance: $setup.userInformation?.amount,
          accountNumber: $setup.userInformation?.accountNumber,
          onCloseMoneyOutSuccessfullyModal: $setup.closeMoneyOutSuccessfullyModal
        }, null, 8, ["balance", "accountNumber", "onCloseMoneyOutSuccessfullyModal"]))
      : _createCommentVNode("", true)
  ], 64))
}